// @flow

import { observer } from "mobx-react";
import * as React from "react";

import TimelineItem from "app/models/TimelineItem";
import Video from "app/models/Video";

import DragHelper from "app/util/DragHelper";
import type { DraggableData } from "app/util/DragHelper";

import DraggableCoreSwitcher from "app/components/DraggableCoreSwitcher/DraggableCoreSwitcher";

import "./TimelinePositioner.scss";

type Props = {
    video: Video,
    item: TimelineItem,
    selectedItem?: TimelineItem,
    onDrag?: Function,
    wizard?: boolean,
    scale: number,
    downSteps?: number,
    children: React.Node,
    isMobile: boolean,
    containerWidth: number
};

const OFFSET_STEP_HEIGHT_PIXELS = 5;

@observer
export default class TimelinePositioner extends React.Component<Props> {
    dragStartTime: number;
    dragStartX: number;
    container: ?HTMLDivElement;

    handleDragStart = (
        event: SyntheticMouseEvent<>,
        data: DraggableData
    ): void => {
        this.dragStartTime = this.props.item.start_time;
        this.dragStartX = event.clientX;

        // $FlowFixMe
        document.body.style.cursor = "pointer";
    };

    handleDrag = (event: SyntheticMouseEvent<>): void => {
        const container = this.container;
        if (!container) throw Error("Container cannot be null/undefined");

        const time = DragHelper.positionToTime(
            container,
            this.dragStartTime,
            this.dragStartX,
            event.clientX,
            this.props.video.duration
        );

        if (!this.props.onDrag)
            throw Error("onDrag function cannot be null/undefined");
        this.props.onDrag(time);
    };

    handleDragStop = (): void => {
        // $FlowFixMe
        document.body.style.cursor = "default";
    };

    render() {
        const video = this.props.video;
        const item = this.props.item;
        const selected = this.props.selectedItem === this.props.item;

        const contentStyle: any = {
            left: `${(item.start_time * 100) / video.duration}%`,
            width: item.duration
                ? `${(item.duration * 100) / video.duration}%`
                : null,
            marginTop:
                OFFSET_STEP_HEIGHT_PIXELS * (this.props.downSteps || 0) + "px",
            minWidth: "2px"
        };

        const classes = ["TimelinePositioner"];

        if (selected) classes.push("TimelinePositioner--selected");
        else if (!selected && this.props.selectedItem)
            classes.push("TimelinePositioner--idle");

        if (item.duration && item.duration / video.duration * this.props.containerWidth < 20) {
            classes.push("TimelinePositioner--narrow");
        }

        const dragDisabled =
            !this.props.onDrag ||
            !selected ||
            !this.props.wizard ||
            this.props.isMobile;

        return (
            <div
                className={classes.join(" ")}
                ref={container => (this.container = container)}
            >
                <div
                    className="TimelinePositioner__content"
                    style={contentStyle}
                >
                    <div className="TimelinePositioner__animateIn">
                        <DraggableCoreSwitcher
                            onStart={this.handleDragStart}
                            onDrag={this.handleDrag}
                            onStop={this.handleDragStop}
                            disabled={dragDisabled}
                            offsetParent={this.container}
                        >
                            <div>{this.props.children}</div>
                        </DraggableCoreSwitcher>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelinePositioner/TimelinePositioner.js